var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlayed-image",style:({height: _vm.height, width: _vm.width, backgroundImage: ("url(" + _vm.src + ")"), backgroundSize: _vm.backgroundSize})},[_c('div',{staticClass:"overlayed-image-overlay"})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65adf2a3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/OverlayedImage.vue
// module id = yUO5
// module chunks = 0